import { Box, Stack } from '@mui/joy'
import { useMemo } from 'react'
import { useIsClient } from 'usehooks-ts'
// import Image from 'next/image'
import Link from 'next/link'
import NoSsr from '@mui/base/NoSsr'
import useTranslation from 'next-translate/useTranslation'
import { Text } from '../../Text'
import Section from '../../Section/Section'
import { Overlay } from '../../Overlay'

export default function FeaturedBlog({ uri, title, author, src, excerpt }) {
    const isClient = useIsClient()
    const { t } = useTranslation('blog')

    const shortContent = useMemo(() => {
        if (!isClient) return ''

        const doc = new DOMParser().parseFromString(excerpt, 'text/html')
        return doc.body.textContent || ''
    }, [excerpt, isClient])

    return (
        <Section
            py={0}
            height="50vh"
            minHeight="480px"
            backdrop={
                <Box
                    width="100%"
                    position="absolute"
                    left={0}
                    top={0}
                    right={0}
                    bottom={0}
                >
                    <Overlay>
                        <Box
                            component="img"
                            src={src}
                            width="100%"
                            height="100%"
                            position="absolute"
                            style={{
                                objectPosition: 'center',
                                objectFit: 'cover',
                            }}
                        />
                    </Overlay>
                </Box>
            }
        >
            <Stack spacing={4} minHeight="50vh" justifyContent="center">
                <Text color="#fff">{t('featuredBlog')}</Text>
                <Link href={uri} prefetch={false}>
                    <Text
                        sx={{
                            fontWeight: 700,
                            color: '#fff',
                            textDecoration: 'none',
                            fontSize: '3rem',
                            '&:hover': {
                                textDecoration: 'underline',
                            },
                        }}
                    >
                        {title}
                    </Text>
                </Link>
                <NoSsr>
                    <Text color="#fff" fontSize="1.25rem">
                        {shortContent.slice(0, 100)}{' '}
                        {shortContent.length > 100 && '...'}
                    </Text>
                </NoSsr>
                <Text size="1rem" fontWeight={300} color="#fff">
                    by {author}
                </Text>
            </Stack>
        </Section>
    )
}
